import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HelperService } from '../../../services';

@Component({
  selector: 'app-terms-and-agreements',
  templateUrl: './agreement-modal.component.html',
  styleUrls: ['./agreement-modal.component.css']
})
export class TermsAndAgreementsComponent implements OnInit {

  @Input() agreementText: string;
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private helperService: HelperService,
    private ds: DomSanitizer
  ) { }

  ngOnInit() { }

  setAgreementText(html: string) {
    if (html) {
      html = html.replace("font-size: 11px;", "font-size: 14px;");
    }
    return this.ds.bypassSecurityTrustHtml(html);
  }

  onClose(event: Event) {
    event.preventDefault();
    this.close.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/agreement-modal/agreement-modal.component.ts